import { FILTER_OPTION_RANGE_SEPARATOR } from "~/modules/dtwin/constants";

/**
 *
 * @param rangeOptionValue
 * @returns
 */
export function getFilterDtwinRangeValueFromRangeOptionValue(
  rangeOptionValue: string,
): string {
  return rangeOptionValue.split(FILTER_OPTION_RANGE_SEPARATOR)[1];
}
